module.exports = __webpack_public_path__ + "static/media/alec.cebd4a87.jpeg";